import DsList from './DsList'

export default Vue => {
  Vue.component(DsList.name, DsList)
}



// WEBPACK FOOTER //
// ./src/components/dsattlist/index.js